export default __webpack_public_path__ + "static/career-a32190b2f2a7c9dc5c78bcc6504ab7bd.svg";